import { BulkActions } from 'customer-data-bulk-actions/components/BulkActions';
import { SELECTION_METHOD_BY_IDS, SELECTION_METHOD_BY_QUERY } from 'customer-data-bulk-actions/constants/selectionMethods';
import { TASK_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { useMemo } from 'react';
import getIn from 'transmute/getIn';
import { useSearchRequestOptionsForView } from '../../hooks/tasksSearchResults';
import { useActiveViewId } from '../../hooks/viewTabs';
import { isFilteringForOnlyCompletedTasks, isIncompleteTasksFilterApplied } from '../../utils/crmSearchFilters';
import BulkAddToQueue from './BulkAddToQueue';
import BulkCompleteTasks from './BulkCompleteTasks';
import BulkDeleteTasksButton from './BulkDeleteTasksButton';
import BulkEditTasksButton from './BulkEditTasksButton';
import BulkStartSelectedTasks from './BulkStartSelectedTasks';
import BulkUncompleteTasks from './BulkUncompleteTasks';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import Small from 'UIComponents/elements/Small';
import { useBulkActionsSyncWarmupCacheFor } from 'customer-data-bulk-actions/hooks/useBulkActionsSyncWarmupCacheFor';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const BulkActionsButtons = props => {
  const viewId = useActiveViewId();
  const {
    crmSearchQuery
  } = useSearchRequestOptionsForView(viewId);
  const filters = getIn(['filterGroups', 0, 'filters'], crmSearchQuery);
  const {
    clearSelection,
    selection,
    querySelected
  } = props;
  const selectionArray = useMemo(() => [...selection], [selection]);
  const selectionNumberArray = useMemo(() => [...selection].map(selectedId => parseInt(selectedId, 10)), [selection]);
  const crmSearchQueryForBulkActions = useMemo(() => {
    return Object.assign({
      query: '',
      objectTypeId: TASK_TYPE_ID,
      sorts: [],
      filterGroups: [{
        filters
      }]
    }, crmSearchQuery);
  }, [crmSearchQuery, filters]);
  useBulkActionsSyncWarmupCacheFor({
    objectIds: selectionArray,
    objectTypeId: TASK_TYPE_ID,
    query: crmSearchQueryForBulkActions
  });
  return /*#__PURE__*/_jsx(BulkActions, {
    selectionObjectTypeId: TASK_TYPE_ID,
    selectionMethod: querySelected ? SELECTION_METHOD_BY_QUERY : SELECTION_METHOD_BY_IDS,
    selectionIds: selectionArray,
    selectionCrmSearchQuery: crmSearchQueryForBulkActions,
    children: /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsxs(UIButtonWrapper, {
        horizontalGap: 20,
        verticalGap: -1,
        children: [/*#__PURE__*/_jsx(BulkStartSelectedTasks, {
          viewId: viewId,
          allSelected: querySelected,
          selection: selectionNumberArray
        }), !isFilteringForOnlyCompletedTasks(filters) && /*#__PURE__*/_jsx(BulkCompleteTasks, {
          allSelected: querySelected,
          clearSelection: clearSelection,
          selection: selectionNumberArray
        }), !isIncompleteTasksFilterApplied(filters) && /*#__PURE__*/_jsx(BulkUncompleteTasks, {
          allSelected: querySelected,
          clearSelection: clearSelection,
          selection: selectionNumberArray
        }), /*#__PURE__*/_jsx(BulkEditTasksButton, {
          clearSelection: clearSelection,
          selection: selectionNumberArray
        }), /*#__PURE__*/_jsx(BulkDeleteTasksButton, {
          allSelected: querySelected,
          clearSelection: clearSelection,
          selection: selectionNumberArray
        }), /*#__PURE__*/_jsx(BulkAddToQueue, {
          clearSelection: clearSelection,
          selection: selectionNumberArray
        })]
      })
    })
  });
};
export default BulkActionsButtons;